import spinner from 'assets/spinner.svg'

const PageSpinner = () => {
    return (
        <div className="flex h-screen w-screen items-center justify-center bg-yellow-10">
            <img className="h-12 animate-spin" src={spinner} alt="loading" />
        </div>
    )
}

export default PageSpinner
